module.exports = __webpack_public_path__ + "img/Categories_bg_001.624a19ba.jpg";